import React from 'react';
import {observer} from 'mobx-react';
import {MatchEventsModuleStageRow} from './match-events-module.stage.row';
import {MatchEventsModuleStageHeader} from "./match-events-module.stage.header";
import {MatchEventsModuleRowViewModel} from "../../models/match-events-module.row-view-model";

export const MatchEventsModuleStage = observer(({stage, controller}) => {
  const {state} = controller;
  const {noEventLabel} = state;
  const {hasNoEvents, eventRows} = stage;

  return (
    <>
      <MatchEventsModuleStageHeader stage={stage}/>
      {
        hasNoEvents ? <div className={'match-event-module-stage-row-no-event'}>{noEventLabel}</div> :
          eventRows.map((row: MatchEventsModuleRowViewModel, index: Number) =>
            <MatchEventsModuleStageRow
              row={row}
              stage={stage}
              controller={controller}
              key={index}
              isLast={eventRows.length - 1 === index}
            />
          )}
    </>
  )
});
